module.exports = __webpack_public_path__ + "img/ZJ5208.a15405f1.png";